@if (isInputActive) {
  <div class="position-relative">
    <div [ngClass]="{ 'border-danger': isError }" class="border-bottom">
      @if (label) {
        <div class="label" [ngClass]="{ 'text-danger': isError }">
          {{ label }}
          @if (isRequired) {
            <span>*</span>
          }
        </div>
      }
      @if (type !== 'textarea') {
        <input
          #inputRef
          type="text"
          [mask]="mask"
          autocomplete="off"
          [(ngModel)]="input"
          [maxlength]="maxLength"
          [disabled]="isDisabled"
          [style.width]="inputWidth"
          [style.height]="inputHeight"
          [placeholder]="placeholder"
          (ngModelChange)="onchange($event)"
          (keydown.enter)="isEnterSave && onDoneClick()"
          class="px-2 fw-lighter fs-md w-100 rounded-top {{ customClass }}"
          [ngClass]="{ disabled: isDisabled }"
          (blur)="onFocusOutCancel()"
        />
      }
      @if (type === 'textarea') {
        <textarea
          cdkTextareaAutosize
          style="min-height: 200px; max-height: 300px"
          [(ngModel)]="input"
          (ngModelChange)="onchange($event)"
          [style.width]="inputWidth"
          [style.height]="inputHeight"
          [placeholder]="placeholder"
          class="px-2 aria-focus fw-lighter fs-md w-100 rounded {{ customClass }}"
          [ngClass]="{ disabled: isDisabled }"
          (keydown.enter)="isEnterSave && onDoneClick()"
          (blur)="onFocusOutCancel()"
        >
        </textarea>
      }
    </div>
    @if (isBtn) {
      <div class="position-absolute top-100 end-0 d-flex z-1 gap-2 py-2">
        <app-button [btnType]="'no-border'" [customClass]="'shadow bg-white p-0'" (onChangeClick)="onDoneClick()">
          <app-icon class="fs-6 h-unset w-unset text-secondary"> done </app-icon>
        </app-button>
        <app-button [btnType]="'no-border'" [customClass]="'shadow bg-white p-0'" (onChangeClick)="onCancelClick()">
          <app-icon class="fs-6 h-unset w-unset text-secondary"> close </app-icon>
        </app-button>
      </div>
    }
    @if (isError && errorText) {
      <div class="shadow z-1 gap-2 p-2 rounded-bottom">
        <span class="fs-sm text-danger text-nowrap">{{ errorText }}</span>
      </div>
    }
  </div>
} @else {
  @switch (type) {
    @case ('default') {
      <div class="py-2 d-flex align-items-center fs-md position-relative" (click)="onTextClick()">
        <div class="w-100 type">
          {{ generalText || input }}
        </div>
        <div class="d-flex">
          <app-icon class="ps-2 fs-6 h-unset w-unset text-secondary">edit</app-icon>
        </div>
      </div>
    }
    @case ('link') {
      <div class="view-edit d-flex align-items-center p-2" (click)="onTextClick()">
        <a
          target="_blank"
          [href]="generalText || input"
          (click)="$event.stopPropagation()"
          class="w-100 fw-lighter text-truncate"
        >
          {{ generalText || input }}
        </a>
        <app-icon class="ps-2 fs-6 h-unset w-unset text-secondary">edit</app-icon>
      </div>
    }
    @case ('text') {
      <div class="view-edit d-flex align-items-center p-2" (click)="onTextClick()">
        <div class="w-100 fw-lighter text-truncate">
          {{ generalText || input }}
        </div>
        <app-icon class="ps-2 fs-6 h-unset w-unset text-secondary">edit</app-icon>
      </div>
    }
    @case ('textarea') {
      <div class="view-edit d-flex align-items-center p-2" (click)="onTextClick()">
        <textarea
          cdkTextareaAutosize
          style="min-height: fit-content; max-height: 200px"
          class="clear-line bg-transparent resize-none w-100 fw-lighter crm-scroll"
          [value]="generalText || input"
          readonly
        >
        </textarea>
        <!--        <div class="w-100 fw-lighter text-truncate">-->
        <!--          {{}}-->
        <!--        </div>-->
        <app-icon class="ps-2 fs-6 h-unset w-unset text-secondary">edit</app-icon>
      </div>
    }
  }
}
